import React, { useEffect, useState } from 'react'
import Charts from 'react-apexcharts'
import { useStateWithCallback } from '../../utils/hooks/useStateWithCallback'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import { IBotAnalyticsFilterInput } from '../../utils/interfaces/IBotAnalyticsFilterInput'
type Props = {
  className: string
  graphAnalyticsFilterInput: any
  setGraphAnalyticsFilterInput: any
  graphAnalyticsData: any
  isLoading: any
  dropDownTitle: any
  setDropDowntitle: any
  botAnalyticsFilterInput: any
}

interface ApexChartsvalue {
  options: {
    chart: {
      id: string
    }
    xaxis: {
      categories: string[]
    }
  }
  series: [
    {
      name: string
      data: number[]
    }
  ]
}

const ConversationsGraph: React.FC<Props> = ({
  className,
  graphAnalyticsFilterInput,
  setGraphAnalyticsFilterInput,
  graphAnalyticsData,
  isLoading,
  dropDownTitle,
  setDropDowntitle,
  botAnalyticsFilterInput
}) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]

  const defaultValues: ApexChartsvalue = {
    options: {
      chart: {
        id: 'basic-bar'
      },
      xaxis: {
        categories: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ]
      }
    },
    series: [
      {
        name: 'Bot Conversation',
        data: [100, 400, 240, 40, 800, 90, 70, 1000, 400, 300, 45, 90]
      }
    ]
  }
  const [state, setState] = useStateWithCallback<ApexChartsvalue>(defaultValues)
  const [isMoreThanThirtyDays, setIsMoreThanThirtyDays] = useState(false)

  useEffect(() => {
    if (!!botAnalyticsFilterInput) {
      const date1 = new Date(botAnalyticsFilterInput.startDate)
      const date2 = new Date(botAnalyticsFilterInput.endDate)
      const Difference_In_Time = date2.getTime() - date1.getTime()
      const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24)
      if (Difference_In_Days > 30) {
        setIsMoreThanThirtyDays(true)
      } else {
        setIsMoreThanThirtyDays(false)
      }
    }
  }, [botAnalyticsFilterInput])

  useEffect(() => {
    if (!!isMoreThanThirtyDays) {
      setDropDowntitle('Weekly')
      setGraphAnalyticsFilterInput((prevValue: IBotAnalyticsFilterInput) => ({
        ...prevValue,
        ['groupBy']: 'week'
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMoreThanThirtyDays])

  useEffect(() => {
    if (!!graphAnalyticsData) {
      const processGraphData = (graphData: any[], graphX: any[], graphY: any[]) => {
        const length = Object.keys(graphData).length

        for (let i = 0; i < length; i++) {
          const dataPoint = graphData[i]

          if (!!dataPoint.date && !isMoreThanThirtyDays) {
            processDateData(dataPoint, graphX, graphY)
          }

          if (!!dataPoint.month) {
            processMonthData(dataPoint, graphX, graphY)
          }

          if (!!dataPoint.week) {
            processWeekData(dataPoint, graphX, graphY)
          }

          if (!!dataPoint.quarter) {
            processQuarterData(dataPoint, graphX, graphY)
          }

          if (!!dataPoint.date && !!isMoreThanThirtyDays) {
            handleMoreThanThirtyDays()
          }
        }

        return { graphX, graphY }
      }

      const processDateData = (dataPoint: any, graphX: any[], graphY: any[]) => {
        graphX.push(dataPoint.date.split('T')[0])
        graphY.push(dataPoint.totalBotConversations as number)
      }

      const processMonthData = (dataPoint: any, graphX: any[], graphY: any[]) => {
        let splitDate = dataPoint.month.split('-')
        graphX.push(`${months[Number(splitDate[1].replace(/^0+/, '') - 1)]} - ${splitDate[0]}`)
        graphY.push(dataPoint.totalBotConversations)
      }

      const processWeekData = (dataPoint: any, graphX: any[], graphY: any[]) => {
        if (dataPoint.week === 1 || dataPoint.week === 52) {
          graphX.push(`Week ${dataPoint.week} ${dataPoint.year}`)
        } else {
          graphX.push(`Week ${dataPoint.week}`)
        }
        graphY.push(dataPoint.totalBotConversations as number)
      }

      const processQuarterData = (dataPoint: any, graphX: any[], graphY: any[]) => {
        graphX.push(`Q${dataPoint.quarter}-${dataPoint.year}`)
        graphY.push(dataPoint.totalBotConversations as number)
      }

      const handleMoreThanThirtyDays = () => {
        setDropDowntitle('Weekly')
        setGraphAnalyticsFilterInput((prevValue: IBotAnalyticsFilterInput) => ({
          ...prevValue,
          ['groupBy']: 'month'
        }))
      }

      const graphX: any[] = []
      const graphY: any[] = []

      processGraphData(graphAnalyticsData.graphAnalytics[0].graphData, graphX, graphY)

      setState((prevState) => ({
        ...prevState,
        options: {
          ...prevState.options,
          xaxis: {
            categories: graphX
          }
        },
        series: [
          {
            name: prevState.series[0].name,
            data: graphY
          }
        ]
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [graphAnalyticsData, botAnalyticsFilterInput])

  const handleDropdownChange = (e: any) => {
    const name = e.target.name
    const value = e.target.value
    console.log(value)
    setDropDowntitle(name)
    setGraphAnalyticsFilterInput((prevValue: IBotAnalyticsFilterInput) => ({
      ...prevValue,
      ['groupBy']: value
    }))
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='fw-bolder text-dark fs-4 fs-md-6 mb-3 text-hover-primary'>
            Conversations Handled By Bot
          </span>
        </h3>

        {/* begin::Toolbar */}
        <div className='card-toolbar' data-kt-buttons='true'>
          <DropdownButton id='dropdown-item-button' title={dropDownTitle}>
            {!isMoreThanThirtyDays && (
              <Dropdown.Item as='button' name='Daily' value={'date'} onClick={handleDropdownChange}>
                Daily
              </Dropdown.Item>
            )}
            <Dropdown.Item as='button' name='Weekly' value={'week'} onClick={handleDropdownChange}>
              Weekly
            </Dropdown.Item>
            <Dropdown.Item
              as='button'
              name='Monthly'
              value={'month'}
              onClick={handleDropdownChange}
            >
              Monthly
            </Dropdown.Item>
            <Dropdown.Item
              as='button'
              name='Quarterly'
              value={'quarter'}
              onClick={handleDropdownChange}
            >
              Quarterly
            </Dropdown.Item>
          </DropdownButton>
        </div>
        {/* end::Toolbar */}
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card'>
        <Charts
          options={state.options}
          series={state.series}
          type='line'
          height={'350px'}
          style={{ zIndex: '0' }}
        />
        {/* begin::Chart */}
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export default ConversationsGraph
